import { Suspense, useState } from "react";
import Modal from 'react-modal';
import ImageSliderModal from "./imageSlider";
const ReviewModal = ({ isOpen, onClose, reviews }) => {
    console.log("reviews" , reviews);
    const [isSliderOpen, setIsSliderOpen] = useState(false);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedImages, setSelectedImages] = useState([]);
    if (!isOpen || !reviews || reviews.length === 0) return null;
const handleImageClick = (index, images) => {
  setSelectedIndex(index); 
  setSelectedImages(images); // Store the images of the selected review
  setIsSliderOpen(true);   
};
    const closeSlider = () => {
      setIsSliderOpen(false);
    };
  //   const handleImageClick = (index) => {
  //     console.log("hiiiiix");
      
  //   setSelectedIndex(index); // Set the index of the clicked image
  //   setIsSliderOpen(true);   // Open the slider modal
  // };
  const formatRating = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const totalStars = 5;
    const stars = [];
  
    for (let i = 0; i < fullStars; i++) {
      stars.push(
        <img
          key={`full-${i}`}
          src={window.getPublicUrl("assets/images/full-star.png")}
          alt="Full Star"
          className="star-icon"
        />
      );
    }
  
    // Half star
    if (hasHalfStar) {
      stars.push(
        <img
          key="half"
          src={window.getPublicUrl("assets/images/half-star.png")}
          alt="Half Star"
          className="star-icon"
        />
      );
    }

  
    return stars;
  };
  
    return (
        <div className='detail-page-modal'>
            <div className='modal-header'>
          <h3>All Reviews</h3>
           <button className='cross'   onClick={onClose}>   <img src={window.getPublicUrl('/assets/images/gray-cross.svg')} alt='close' /></button>
          </div>
          <div className='modal-body scrollable-modal-body'>
        
          {reviews.map((review, index) => (
            <div key={index}>
              <h4>{review?.User?.name}'s Review</h4>
              <p className="star">
                      {review?.rating}  {formatRating(review?.rating)}
                      </p>
              <p><strong>Review:</strong> {review?.review_text}</p>
              <p><strong>Date:</strong> {new Date(review?.date_of_experience).toLocaleDateString()}</p>
              <div className="review-images">
              {review.ReviewImages.map((img, index) => (
  <img
    key={img.id}
    src={img.url}
    alt="venueDetails"
    className="thumbnail"
    height={100}
    width={100}
    onClick={() => handleImageClick(index, review?.ReviewImages)}
  />
))}


              </div>
              <hr />
            </div>
          ))}
 
        
        </div>

        <Suspense fallback={<div>Loading...</div>}>
  <Modal
    isOpen={isSliderOpen}
    onRequestClose={closeSlider}
    contentLabel="Image Slider Modal"
    shouldCloseOnOverlayClick={false}
    ariaHideApp={false}
    overlayClassName="modal-overlay review-modal"
    portalClassName="review-modal-portal"
  >
<ImageSliderModal 
  isOpen={isSliderOpen} 
  onClose={closeSlider} 
  selectedIndex={selectedIndex} 
  images={selectedImages} // ✅ Now correctly passing selected images
/>
  </Modal>
</Suspense>
      </div>
    );
  };
  
  export default ReviewModal;